module.exports = __webpack_public_path__ + "img/gb.28930444.png";